import React from "react";
import { Box, Checkbox, FormControlLabel, TextField } from "@material-ui/core";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import styles from "./style";
import { GENDER_OPTIONS, SEARCH_TIME_OUT } from "../../utils/constants";
import CustomSingleSelect from "../custom-single-select/CustomSingleSelect";
import { setDepartment, setEmployeeType, setFormerPublicReprsentative, setGender, setPhoneNumber, setPost, setPublicRepresentativePost, setSearchText, setStaffCodeNumber, setTenureDateFrom, setTenureDateTo } from "../../reduxToolkit/reducers/searchFilterSlice";
import { Search } from "@material-ui/icons";
import { EMPLOYEE_TYPE } from "../../utils/constants/forms";
import NepaliCalender from "../nepali-calender";
import { DateUtils } from "../../utils/dateUtils";

export default function RegisterFilter({ fieldVisibility, postOptions, showSearchField, defaultTenureFromDate = 1649894400000, defaultTenureToDate = 1807660800000, ...props }) {
  const classes = styles();
  const dispatch = useDispatch();
  const { register } = useForm();
  const [visibleFields, setVisibleFields] = useState(fieldVisibility);
  const [showScrollButtons, setShowScrollButtons] = useState(false);
  const phoneTimeoutRef = useRef(null);
  const searchTimeoutRef = useRef(null);
  const staffCodeTimeoutRef = useRef(null);
  const publicRepresentativeRef = useRef(null);

  const { post, gender, phoneNumber, searchText, tenureDateFrom, tenureDateTo, staffCodeNumber, department, employeeType, formerPublicRepresentative, publicRepresentativePost } = useSelector((state) => state.searchFilter);

  useEffect(() => {
    setVisibleFields(fieldVisibility);
  }, [fieldVisibility]);

  const handlePostChange = (selectedOption) => {
    dispatch(setPost(selectedOption?.value));
  };

  const handleGenderChange = (selectedOption) => {
    dispatch(setGender(selectedOption?.value));
  };

  const handlEemployeeTypeChange = (selectedOption) => {
    dispatch(setEmployeeType(selectedOption?.value));
  };
  const handleDepartmentChange = (selectedOption) => {
    dispatch(setDepartment(selectedOption?.value));
  };

  const handletenureDateFromSelect = (name, dateInMilli) => {
    dispatch(setTenureDateFrom(dateInMilli));
  }

  const handletenureDateToSelect = (name, dateInMilli) => {
    dispatch(setTenureDateTo(dateInMilli));
  }

  const handlePhoneNumberChange = (e) => {
    const value = e.target.value.trim();

    if (phoneTimeoutRef.current) {
      clearTimeout(phoneTimeoutRef.current);
    }

    phoneTimeoutRef.current = setTimeout(() => {
      dispatch(setPhoneNumber(encodeURIComponent(value)));
    }, SEARCH_TIME_OUT);
  };
  const handleStaffCodeNumberChange = (e) => {
    const value = e.target.value.trim();

    if (staffCodeTimeoutRef.current) {
      clearTimeout(staffCodeTimeoutRef.current);
    }

    staffCodeTimeoutRef.current = setTimeout(() => {
      dispatch(setStaffCodeNumber(encodeURIComponent(value)));
    }, SEARCH_TIME_OUT);
  };


  const onSearchParamChange = (e) => {
    const searchText = e.target.value.trim();
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    searchTimeoutRef.current = setTimeout(() => {
      dispatch(setSearchText(encodeURIComponent(searchText)));
    }, SEARCH_TIME_OUT);
  };

  const onPublicRepresentativePostChange = (e) => {
    const searchText = e.target.value.trim();
    if (publicRepresentativeRef.current) {
      clearTimeout(publicRepresentativeRef.current);
    }
    publicRepresentativeRef.current = setTimeout(() => {
      dispatch(setPublicRepresentativePost(encodeURIComponent(searchText)));
    }, SEARCH_TIME_OUT);
  };


  const decodedPhoneNumber = decodeURIComponent(phoneNumber || "");
  const decodedSearchText = decodeURIComponent(searchText || "");
  const decodedStaffCodeNumber = decodeURIComponent(staffCodeNumber || "");
  const decodedPublicRepresentativePost = decodeURIComponent(publicRepresentativePost || "");
  const formattedDateFrom = tenureDateFrom ? DateUtils.getDateFromMilliseconds(tenureDateFrom, "BS", false) : defaultTenureFromDate;
  const formattedDateTo = tenureDateTo ? DateUtils.getDateFromMilliseconds(tenureDateTo, "BS", false) : defaultTenureToDate;

  const scrollableRef = useRef(null);
  useEffect(() => {
    const handleScrollButtonsVisibility = () => {
      const scrollableElement = scrollableRef.current;
      setShowScrollButtons(scrollableElement.scrollWidth > scrollableElement.clientWidth);
    };

    handleScrollButtonsVisibility();
    window.addEventListener('resize', handleScrollButtonsVisibility);

    return () => {
      window.removeEventListener('resize', handleScrollButtonsVisibility);
    };
  }, []);

  const handleScrollLeft = () => {
    if (scrollableRef.current) {
      scrollableRef.current.scrollBy({ left: -100, behavior: 'smooth' });
    }
  };

  const handleScrollRight = () => {
    if (scrollableRef.current) {
      scrollableRef.current.scrollBy({ left: 100, behavior: 'smooth' });
    }
  };

  const handleFormerPublicRepresentativeChecked = (e) => {
    dispatch(setFormerPublicReprsentative(e.target.checked));
  }

  return (
    <Box position={"relative"}>
      {showScrollButtons && (
        <Box onClick={handleScrollLeft} className={classes.backwardButton}>
          <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px' }} />
        </Box>
      )}
      <Box className={classes.searchFilterWrapper} ref={scrollableRef}>
        {showSearchField && <Box className={classes.searchFieldSize}>
          <TextField
            className={classes.searchFieldSize}
            label={props.searchFieldLabel}
            name="searchText"
            type="text"
            defaultValue={decodedSearchText}
            size="small"
            onChange={onSearchParamChange}
            variant="outlined"
            inputRef={register}
            InputProps={{
              endAdornment: <Search fontSize="small" />,
            }}
          />
        </Box>}
        {visibleFields?.post && (
          <Box className={classes.searchFieldSize}>
            <CustomSingleSelect
              label="Post"
              name="post"
              options={postOptions}
              defaultValue={post}
              onChange={handlePostChange}
            />
          </Box>
        )}
        {visibleFields.tenureDateFilter &&
          <Box className={classes.dateRangeContainer} display="flex" alignItems="center" mr={1}>
            <Box className={classes.fieldSize}>
              <NepaliCalender
                id="dartaa-from-date"
                label="कार्यकाल देखी"
                onChange={handletenureDateFromSelect}
                defaultDate={formattedDateFrom}
              />
            </Box>
            <Box className={classes.fieldSize}>
              <NepaliCalender
                id="dartaa-to-date"
                onChange={handletenureDateToSelect}
                label="कार्यकाल सम्म"
                defaultDate={formattedDateTo}
              />
            </Box>
          </Box>
        }
        {visibleFields?.gender && (
          <Box className={classes.searchSelect}>
            <CustomSingleSelect
              label="लिङ्ग"
              name="gender"
              options={GENDER_OPTIONS}
              defaultValue={gender}
              onChange={handleGenderChange}
            />
          </Box>
        )}
        {visibleFields?.staffCodeNumber && (
          <Box className={classes.searchFieldSize}>
            <TextField
              label="कर्मचारी संकेत नं"
              name="staffCodeNumber"
              type="number"
              size="small"
              variant="outlined"
              defaultValue={decodedStaffCodeNumber}
              inputRef={register}
              onWheel={(e) => e.target.blur()}
              onChange={handleStaffCodeNumberChange}
              fullWidth
            />
          </Box>
        )}
        {visibleFields?.department && (
          <Box className={classes.searchFieldSize}>
            <CustomSingleSelect
              label="Department"
              name="department"
              options={props.departmentData}
              defaultValue={department}
              onChange={handleDepartmentChange}
            />
          </Box>
        )}
        {visibleFields?.employeeType && (
          <Box className={classes.searchFieldSize}>
            <CustomSingleSelect
              label="Employee Type"
              name="employeeType"
              defaultValue={employeeType}
              options={EMPLOYEE_TYPE}
              onChange={handlEemployeeTypeChange}
            />
          </Box>
        )}
        {visibleFields?.phoneNumber && (
          <Box className={classes.searchFieldSize}>
            <TextField
              label="सम्पर्क नम्बर"
              name="phoneNumber"
              type="number"
              size="small"
              variant="outlined"
              defaultValue={decodedPhoneNumber}
              inputRef={register}
              onWheel={(e) => e.target.blur()}
              onChange={handlePhoneNumberChange}
              fullWidth
            />
          </Box>
        )}
        {visibleFields.publicRepresentativePost && <Box className={classes.searchFieldSize}>
          <TextField
            className={classes.searchFieldSize}
            label="पद बाट खोज्नुहोस्"
            name="publicRepresentativePost"
            type="text"
            defaultValue={decodedPublicRepresentativePost}
            size="small"
            onChange={onPublicRepresentativePostChange}
            variant="outlined"
            inputRef={register}
          />
        </Box>}
        {visibleFields.formerPublicRepresentative && (
          <Box>
            <FormControlLabel
              label="भूतपूर्व जन प्रतिनिधि"
              control={
                <Checkbox
                  onChange={handleFormerPublicRepresentativeChecked}
                  defaultChecked={formerPublicRepresentative}
                  variant="outlined"
                  color="primary"
                />
              }
            />
          </Box>
        )}
      </Box>
      {showScrollButtons && (
        <Box onClick={handleScrollRight} className={classes.forwardButton}>
          <ArrowForwardIosIcon fontSize="small" />
        </Box>
      )}
    </Box>
  );
}
